// extracted by mini-css-extract-plugin
module.exports = {"rangePicker":"date-picket_rangePicker__3roUX"};